<script>
  import config from '../../libs/config.js';

  import api from '../../api'
  import _ from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  
  import func from '../../libs/functions.js';
  import _system from '../../libs/system'

	export default 
	{
		name: 'Introduction',
		data() 
        {
        	return {
            loading: false,
            workspace: '',
            jobTitle: '',
            companySize: '',
            error: false,
            departments: []
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
          ...mapGetters('workspaces', ['workspaces', 'currentWorkspace']),
          workspacem(){
            return this.currentWorkspace.name
          }
        },
      methods: {
        ...mapActions('tags', ['setTags']),
        ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
        ...mapActions('workspaceusers', ['setWorkspaceusers']),
        next(){

          if(!this.workspace){
            return alert('Cannot be empty');
          }

          if(this.workspaces.length == 2){
            return alert('Cannot create more than 2 workspaces');
          }

          this.loading = true

          let payload = { "name": this.workspace }
          _system.services.workspaces.create(payload, (err, workspace) => {
            if (err) return console.log(err);
            
              this.pushWorkspace(workspace);

              this.setCurrentWorkspace(workspace);

              let payload = {
                workspace: workspace._id,
                user:  this.getUser._id,
                tags :  [this.tagsByName['Admin']._id],
              }
              _system.services.workspaceusers.add(payload, (err, workspaceusers) => {
                if (err) return console.log(err);
                this.setWorkspaceusers(workspaceusers);
                this.loading = false;
                //this.$router.push({ name: "accounts" });
                window.location.replace("/accounts");
              });
          })

        },
        update(){
          let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            },
            body: {
              name: this.workspacem
            }
          }
          _system.services.workspaces.update(payload, (err, workspace) => {
            this.setCurrentWorkspace(workspace);
            //this.$router.push({ name: "accounts" });
            window.location.replace("/accounts");
          });
        }
      }
	}
</script>

<template>
  <div style="height:100%;" class="ui grid centered middle aligned stackable">



    <div class="nine wide computer sixteen wide mobile column">
      <div class="ui basic large segment">
        <h2>Welcome 🎉</h2>
        <p>Hello {{getUser.name}} 👋 </p>

          <div data-aos="fade-in"  class="ui large form">
          <div class="field">
            <label>Title</label>
            <div v-bind:class="{ error: error }" class="ui input">
            <input  v-model="jobTitle" placeholder="Customer Success Manager" v-on:keyup.enter="next()" type="text">
            <input  :value="companySize" @input="companySize = $event.target.value" placeholder="aa" v-on:keyup.enter="update()" type="text">
            </div>
          </div>
           <div class="ui divider"></div>
                     <button @click="next()" v-bind:class="{ loading: loading }" :disabled="loading" class="ui large green button right floated">Next</button>
        </div>
      </div>
    </div>

<!--     <div class="nine wide computer sixteen wide mobile column">
      <table>
        <tbody>
          <tr>
            <td style="padding-right: 1rem;" data-label="Name"> <b>Step 1</b> - Create Online Workspace</td> 
            <td style="padding-right: 1rem; opacity: 0.2;" data-label="Name"><b>Step 2</b> - Setup Team</td>
            <td style="padding-right: 1rem; opacity: 0.2;" data-label="Name"><b>Step 2</b> - Connect Social Accounts 🚀</td>
          </tr>
        </tbody>
      </table>
   <div class="ui divider"></div>
      <div class="ui basic large segment">
        <h2>Welcome 🎉</h2>
        <p>Hello {{getUser.name}} 👋 </p>
        <p>Let's create your Team. If you're solo! Just skip.</p>

          <div data-aos="fade-in"  class="ui large form">
          <div class="field">
            <label>Company or Team Name</label>
            <div v-bind:class="{ error: error }" class="ui input">
            <input v-if="workspaces.length == 1" v-model="workspace" placeholder="Apple / Samsung / Eddie's Workspace" v-on:keyup.enter="next()" type="text">
            <input v-if="workspaces.length == 2" :value="workspacem" @input="currentWorkspace.name = $event.target.value" placeholder="Apple / Samsung / Eddie's Workspace" v-on:keyup.enter="update()" type="text">
            </div>
          </div>
           <div class="ui divider"></div>
                     <button  v-if="workspaces.length == 1" @click="next()" v-bind:class="{ loading: loading }" :disabled="loading" class="ui large green button right floated">Next</button>
                     <button  v-if="workspaces.length == 2" @click="update()" v-bind:class="{ loading: loading }" :disabled="loading" class="ui large green button right floated">Update</button>
                     <router-link  to="/introduction/page">
                      <div  v-if="workspaces.length == 1" style="background: transparent;" class="ui large button right floated">Skip</div>
                     </router-link>
        </div>
      </div>
    </div> -->

  </div>
</template>



// WEBPACK FOOTER //
// src/components/dashboard/introduction.vue